import React from "react";
import Avatar from "@material-ui/core/Avatar";
import {
  UserAvatar,
  UserListContainer,
  UserListItem,
  UserName,
} from "./users-search-results.styles";
import { makeKey } from "../../../../utils/helpers";
import { UsersSearchResultsProps } from "./users-search-results.props";

export const UsersSearchResults = (props: UsersSearchResultsProps) => {
  if (!props.users.length) {
    return null;
  }

  return (
    <>
      <UserListContainer className={props.styleClass}>
        {props.users.map((user) => (
          <UserListItem
            key={makeKey("user", user.id)}
            onClick={() => {
              props.handleSelect(user);
            }}
          >
            <UserAvatar>
              <Avatar title={`${user.firstName} ${user.lastName}`} alt={`${user.firstName} ${user.lastName}`} src={(user.profileImageUrl) ? user.profileImageUrl : "/profile.png" } />
            </UserAvatar>
            <UserName>{user.firstName +' '+ user.lastName}</UserName>
          </UserListItem>
        ))}
      </UserListContainer>
    </>
  );
};
